<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
      :for="inputId"
    >{{ label }}</label>
    <div
      class="control"
      :class="{ 'is-loading': isLoading }"
    >
      <textarea
        v-bind="$attrs"
        :id="inputId"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="textarea"
        :class="{ 'is-danger': hasError }"
        type="text"
      />
    </div>
    <p
      class="help is-danger"
      v-if="hasError"
    >{{ error[0] }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  inheritAttrs: false,
  props: {
    /** The input value */
    modelValue: String,
    /** Label for the field */
    label: String,
    /** Array of error messages */
    error: Object,
    /** When true, adds a spinner to the input */
    isLoading: Boolean,
    /** ID assigned to the input if present, otherwise uses the label */
    htmlId: String
  },
  computed: {
    hasError() {
      return this.error !== undefined
    },
    inputId() {
      if (this.htmlId === undefined) {
        if (this.label === undefined) {
          return null
        }
        return this.label.replaceAll(" ", "-").toLowerCase()
      } else {
        return this.htmlId
      }
    }
  }
})
</script>